var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStateEmptySmall = function SvgStateEmptySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17ZM12.0002 14.656L14.8172 16.376L14.0512 13.166L16.5582 11.019L13.2682 10.755L12.0002 7.708L10.7322 10.755L7.44223 11.019L9.94923 13.166L9.18323 16.376L12.0002 14.657V14.656Z",
    fill: "currentColor"
  })));
};
export default SvgStateEmptySmall;